import { ImageComponent } from '..';
import { EditorComponent } from '../types';

interface DocumentComponentProps extends EditorComponent {
}

const DocumentComponent = (props: DocumentComponentProps) => <ImageComponent {...props} mode="Document" />;

export { DocumentComponent };
